import { render, staticRenderFns } from "./NotFoundFrame.vue?vue&type=template&id=b1fecd3e&"
import script from "./NotFoundFrame.vue?vue&type=script&lang=js&"
export * from "./NotFoundFrame.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundFrame.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports